export default {
  from: 'פתוח מהשעה',
  until: 'עד השעה',
  submit: 'עדכן שעות פעילות',
  close: 'סגור',
  workingHours: 'שעות פעילות'
};
